import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["bar", "value", "circle", "progress"];
  static values = {
    reverse: { type: Boolean, default: false },
  };

  barTargetConnected(element) {
    const percentage = element.dataset.indicatorPercentageValue || 0;
    element.style.width = `${percentage}%`;
  }

  valueTargetConnected(element) {
    const bar = element.parentElement.dataset.indicatorPercentageValue;
    const circle = element.closest('[data-indicator-target="circle"]')?.dataset
      .indicatorPercentageValue;
    const self = element.dataset.indicatorPercentageValue;
    const percentage = bar || circle || self || 0;
    element.textContent = percentage;
  }

  circleTargetConnected(element) {
    const percentage = element.dataset.indicatorPercentageValue || 0;
    const reverse = element.dataset.indicatorReverseValue === "true";

    this.progressTargets.forEach((progress) => {
      const radius = progress.getAttribute("r");
      const circumference = 2 * Math.PI * parseFloat(radius);

      progress.style.strokeDasharray = circumference;

      const offset = reverse
        ? (percentage / 100) * circumference
        : ((100 - percentage) / 100) * circumference;

      progress.style.strokeDashoffset = offset;
    });
  }
}
